// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_av-3";
export var contentContainer = "_av-0";
export var editorContainer = "_av-1";
export var quillInputForm = "_av-2";
export var zoneDivider = "_av-4";